import React, { Fragment, useState } from "react";
import { toastr } from "components/toastr";
import { isMobile } from "react-device-detect";
import { useDispatch } from "react-redux";
import { Trans, useTranslation } from "react-i18next";
import { setClickLogapi } from "helpers";

import { JAVASCRIPT_VOID } from "constant/config";
import {fetchStoryHiddenReason} from "actions/vod.storyHidden.action";

import { CLEAR_VODS } from "actions/vods.action";

const CatchStoryHiddenReasonLayer = ({ storyHiddenInfo, close, closeLayer }) => {

	const dispatch = useDispatch();
	const { t } = useTranslation();
	// 삭제 사유
	const [reason, setReason] = useState("");
	// 삭제 버튼 활성화
	const [active, setActive] = useState(false);

	const onChange = (e) => {
		setReason(e.target.value);
		e.target.value.length >= 5 && e.target.value.length <= 200
		  ? setActive(true)
		  : setActive(false);
	}

	const handleCatchStoryHidden = async (e) => {
		// 2차 삭제 방어 팝업 삭제 버튼 click 로그
		setClickLogapi("story_separate_delete_popup2", {contents_type : "catch_story", action : "click", button_type : "to_delete"});

		// 캐치 스토리 삭제 API
		let returnStoryHidden = await dispatch(fetchStoryHiddenReason(storyHiddenInfo.idx, "delete", true, reason));

		toastr.success(returnStoryHidden.message, {
			timeOut: 2000,
		});
		
		close(closeLayer);

		// 삭제 성공 시 리스트 갱신
		if (returnStoryHidden.result === 1) {
			dispatch({ type: CLEAR_VODS });
		}
	}

	// 2차 삭제 방어 팝업 취소 버튼
    const handleDeletePopupClick = () => {
        setClickLogapi("story_separate_delete_popup2", {contents_type : "catch_story", action : "click", button_type : "to_exit_btn"});
        close(closeLayer);
    }

	// PC 2차 삭제 방어 팝업 닫기 아이콘
    const handleDeleteIconPopupClick = () => {
        setClickLogapi("story_separate_delete_popup2", {contents_type : "catch_story", action : "click", button_type : "to_exit_icon"});
        close(closeLayer);
    }

	return (
		<Fragment>
			{!isMobile && (
				<button type="button" className="close" onClick={handleDeleteIconPopupClick}><span>레이어 닫기</span></button>
			)}
            <div className="pop-body">
				<h2><Trans>Catch 스토리 삭제</Trans></h2>
				<textarea name="" id="" placeholder={t("삭제 사유를 입력해주세요.")} onKeyUp={onChange}></textarea>
				<p className="guide_text error"><Trans>삭제 사유는 5자 ~ 200자까지 입력 가능합니다.</Trans></p>
			</div>
			<div className="pop-btn">
				{isMobile ? (
					<>
						<a href={JAVASCRIPT_VOID} className="btn" onClick={handleDeletePopupClick}><Trans>취소</Trans></a>
						<button type="submit" className="btn" disabled={!active} onClick={handleCatchStoryHidden}><Trans>삭제</Trans></button>
					</>
				) : (
					<>
						<button type="submit" className="btn" disabled={!active} onClick={handleCatchStoryHidden}><Trans>삭제</Trans></button>
						<a href={JAVASCRIPT_VOID} className="btn" onClick={handleDeletePopupClick}><Trans>취소</Trans></a>
					</>
				)}

			</div>
		</Fragment>
	);
};

export default CatchStoryHiddenReasonLayer;
